import React, { useRef } from 'react'
import { isEmpty } from 'lodash/fp'
import { Location } from '@reach/router'
import { navigate } from 'gatsby'

const withLocation = (Component) => (rest) => (
  <Location>
    {({ location }) => <Component location={location} {...rest} />}
  </Location>
)

const queryParams = (Component) => {
  function Query({ location, ...rest }) {
    const { current: params } = useRef(new URLSearchParams(location.search))
    const getParams = () => {
      let result = {}
      for (let entry of params) {
        const [key, value] = entry
        result[key] = value
      }
      return result
    }

    const setParams = (searchParams) => {
      for (let key in searchParams) {
        // eslint-disable-next-line no-prototype-builtins
        if (searchParams.hasOwnProperty(key)) {
          let val = searchParams[key]
          isEmpty(val)
            ? params.delete(key)
            : params.set(key, JSON.stringify(val))
        }
      }

      navigate(`?${params.toString()}`)
    }

    return (
      <Component
        location={location}
        getParams={getParams}
        setParams={setParams}
        {...rest}
      />
    )
  }
  return withLocation(Query)
}

export default queryParams
